import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=fc774f2a&lang=pug&"
import script from "./OrderConfirm.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports